import { initialListPaginationMeta } from "utils/helpers/pagination";

import { BackWallTypeForm, BackWallTypeState } from "../types";

export const initialBackWallTypeForm: BackWallTypeForm = {
  backWallCode: "",
  backWallDesc: "",
  bump: "",
};

export const initialBackWallTypeMeta = initialListPaginationMeta;

export const initialState: BackWallTypeState = {
  loading: false,
  saving: false,
  list: [],
  page: 1,
  perPage: 20,
  meta: initialBackWallTypeMeta,
  error: null,
  detail: null,
  detailLoading: false,
  detailError: null,
  isAddModalOpen: false,
  form: initialBackWallTypeForm,
};
